<template>
    <v-card
        color="white"
        height="32rem"
        width="23rem"
        class="mx-auto product-overview-card"
        elevation="10"
    >
        <v-img
            v-if="product.image"
            :src="product.image"
            :lazy-src="product.thumbnail"
            :alt="product.name + ' image'"
            height="16rem"
            @click="$emit('click')"
        >
        </v-img>
        <div @click="$emit('click')" v-else class="no-image text-center d-flex">
            <div class="my-auto mx-auto">No product image available.</div>
        </div>
        <v-card-title @click="$emit('click')">
            <span class="product-title" v-text="product.name"></span>
        </v-card-title>
        <v-card-subtitle @click="$emit('click')">
            <div class="product-subtitle text-truncate" v-text="product.short_desc"></div>
            <div><a class="view-link">Nutrition & More</a></div>
        </v-card-subtitle>
        <v-card-text>
            <div class="d-flex" @click="$emit('click')">
                <div class="mr-2" v-for="attribute in product.attributes" :key="attribute.name">
                    <v-img :title="attribute.name" :src="attribute.icon" :alt="attribute.name" height="2rem" width="2rem"></v-img>
                </div>
            </div>
            <div class="product-actions">
                <div class="d-flex flex-row align-start justify-space-between w100">
                    <div class="d-flex flex-column align-start pt-2">
                        <span class="price-label" v-text="formatUSD(parseFloat(product.price)*qtySelected)"></span>

                    </div>
                    <div class="d-flex flex-column align-center">
                        <qty-selector v-model="qtySelected"></qty-selector>
                        <span class="price-sublabel">{{product.price_unit}}</span>
                    </div>
                    <v-btn
                        small
                        :color="buttonColor"
                        class="atc-btn mt-1"
                        @click="addProductsToCart"
                        :loading="loading"
                        :disabled="loading"
                        :depressed="loading || flatBtn"
                        width="95"
                        rounded
                    >{{buttonText}}
                    </v-btn>
                </div>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
    import QtySelector from "../QtySelector";
    import {formatUSD} from "../../utils/format";
    import {mapActions} from 'vuex';

    export default {
        name: "ProductOverviewCard",
        props: [
            'product'
        ],
        components: {
            QtySelector
        },
        data(){
            return {
                qtySelected: 1,
                loading: false,
                buttonColor: 'primary',
                buttonText: 'Add to Cart'
            }
        },
        methods: {
            ...mapActions({addProductsToCartAction: 'addProductsToCart'}),
            formatUSD(value){
                return formatUSD(value)
            },
            async addProductsToCart(){
                if (this.flatBtn || this.loading) return;
                try{
                    this.loading = true;
                    await this.addProductsToCartAction({ productId: this.product.id, qty: this.qtySelected, nuts: false });
                    this.qtySelected = 1;
                    this.loading = false;
                    this.buttonColor = 'success';
                    this.buttonText = 'Success!';
                    setTimeout(() => {
                        this.buttonColor = 'primary';
                        this.buttonText = 'Add to Cart';
                        }, 2000
                    );
                } catch(e){
                    this.loading = false;
                    console.log(e)  // TODO: ERROR HANDLING
                }
            }
        },
        computed: {
            flatBtn(){
                return this.buttonColor === 'success'
            }
        }
    }
</script>

<style scoped>
.product-overview-card{
    cursor: pointer;
    position: relative;
}

.product-title{
    color: var(--v-primary-base);
    font-weight: bold;
}

.atc-btn{
    font-family: "Open Sans", sans-serif;
    color: var(--v-secondary-base) !important;
    text-transform: none;
}

.price-label{
    color: var(--v-primary-base);
    font-size: 1.7rem;
    font-weight: bold;
}

.product-actions{
    position: absolute;
    bottom: 16px;
    left: 16px;
    right: 16px;
}

>>>.v-card__text{
    padding-bottom: 0;
}

>>>.v-card__subtitle {
    padding-bottom: 8px;
}

.price-sublabel{
    font-size: .7rem;
}

.v-btn .v-btn__content .v-icon {
    color: var(--v-primary-base);
}

.no-image{
    height: 16rem;
    background: var(--v-secondary-base);
    color: var(--v-primary-base);
}

.view-link{
    text-decoration: underline;
}
</style>